export const LOG_EVENT = {
  WEB_PUSH_IMPRESSION: 'web_push_impression',
  SUBMIT_AGREEMENT: 'web_submit_agreement'
} as const;
